import styled from 'styled-components'
import { Button, InputNumber, Row, Typography } from 'antd/es'

const Container = styled.div`
  padding: 4%;
`
const StyledRow = styled(Row)`
  margin: 0.5rem 0;
`
const StyledText = styled(Typography)`
  font-size: 0.9rem;
  line-height: 2rem;
`

const StyledInputNumber = styled(InputNumber)`
  width: 95%;
  .ant-input-number-handler-wrap {
    display: none;
  }
  input {
    text-align: center;
  }
`

interface StyledInputProps {
  width?: number
}

const StyledInput = styled(InputNumber)<StyledInputProps>`
  width: ${props => `${props.width ?? '62.4'}%`};
  .ant-input-number-handler-wrap {
    display: none;
  }
`

const StyledEmptyContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  height: 300px;
`
const StyledMandatoryField = styled.span`
  color: rgb(255 127 129);
`
const StyledButton = styled(Button)``

export {
  Container,
  StyledRow,
  StyledText,
  StyledInputNumber,
  StyledInput,
  StyledButton,
  StyledEmptyContainer,
  StyledMandatoryField,
}
